import store from '../containers/App/store';
import { setResetAlertEmailRecipients } from '../redux/reducers/alertEmailRecipientsReducer';
import { setResetAlertingTools } from '../redux/reducers/alertingToolsReducer';
import { setResetAlert } from '../redux/reducers/alertReducer';
import { setResetALienVault } from '../redux/reducers/alienVaultReducer';
import { setResetApiKey } from '../redux/reducers/apiKeyReducer';
import { setResetAssessment } from '../redux/reducers/assessmentsReducer';
import { setResetAssetManagement } from '../redux/reducers/assetManagementReducer';
import { setResetAsset } from '../redux/reducers/assetReducer';
import { setResetAuth } from '../redux/reducers/authReducer';
import { setResetAuvik } from '../redux/reducers/auvikReducer';
import { setResetBackup } from '../redux/reducers/backupReducer';
import { setResetCompanyService } from '../redux/reducers/companyServiceReducer';
import { setResetControlGroup } from '../redux/reducers/controlGroupTemplatesReducer';
import { setResetCustomer } from '../redux/reducers/customerReducer';
import { setResetExabeam } from '../redux/reducers/exabeamReducer';
import { setResetGraphApi } from '../redux/reducers/graphapiReducer';
import { setResetJiraTicket } from '../redux/reducers/jiraTicketsReducer';
import { setResetManagedBackup } from '../redux/reducers/managedbackupReducer';
import { setResetMbDashboard } from '../redux/reducers/mbdashboardReducer';
import { setResetMbUsage } from '../redux/reducers/mbUsageReducer';
import { setResetModalToggle } from '../redux/reducers/modalToggleReducer';
import { setResetMonitoring } from '../redux/reducers/monitoringReducer';
import { setResetMsSentinel } from '../redux/reducers/mssentinelReducer';
import { setResetMssReport } from '../redux/reducers/mssReportQueueReducer';
import { setResetNotification } from '../redux/reducers/notificationReducer';
import { setResetObjectStorage } from '../redux/reducers/objectStorageReducer';
import { setResetOneServer } from '../redux/reducers/oneServerReducer';
import { setResetOpenNebula } from '../redux/reducers/openNebulaVMReducer';
import { setResetOrder } from '../redux/reducers/orderReducer';
import { setResetPermissions } from '../redux/reducers/permissionsReducer';
import { setResetPowerbi } from '../redux/reducers/powerbiReducer';
import { setResetPriceBook } from '../redux/reducers/pricebookReducer';
import { setResetPrivateNetwork } from '../redux/reducers/privateNetworkReducer';
import { setResetQuickBooks } from '../redux/reducers/quickbooksReducer';
import { setResetRbac } from '../redux/reducers/rbacReducer';
import { setResetRedirect } from '../redux/reducers/redirectReducer';
import { setResetResourcePermission } from '../redux/reducers/resourcePermissionReducer';
import { setResetResource } from '../redux/reducers/resourceReducer';
import { setResetResourcesStorage } from '../redux/reducers/resourceStorageReducer';
import { setResetResourcesUsage } from '../redux/reducers/resourceUsageReducer';
import { setResetRoleMng } from '../redux/reducers/roleMembershipReducer';
import { setResetRole } from '../redux/reducers/roleReducer';
import { setResetSentinelOne } from '../redux/reducers/sentinelOneReducer';
import { setResetServices } from '../redux/reducers/servicesReducer';
import { setResetSharepoint } from '../redux/reducers/sharepointReducer';
import { setResetSites } from '../redux/reducers/sitesReducers';
import { setResetStd } from '../redux/reducers/standardReducer';
import { setResetUser } from '../redux/reducers/userReducer';
import { setResetVirtualMachine } from '../redux/reducers/virtualMachineReducer';
import { setResetVirtualRouter } from '../redux/reducers/virtualRouterReducer';
import { setResetVmTemplate } from '../redux/reducers/vmTemplateReducer';
import { setResetVulnerability } from '../redux/reducers/vulnerabilityScansReducer';

export const ResetIndexedDb = (causedFrom) => {
  console.log('Reset_prop', causedFrom);
  store.dispatch(setResetRbac());
  store.dispatch(setResetAlertEmailRecipients());
  store.dispatch(setResetAlertingTools());
  store.dispatch(setResetAlert());
  store.dispatch(setResetALienVault());
  store.dispatch(setResetApiKey());
  store.dispatch(setResetAssessment());
  store.dispatch(setResetAssetManagement());
  store.dispatch(setResetAsset());
  store.dispatch(setResetAuth());
  store.dispatch(setResetAuvik());
  store.dispatch(setResetBackup());
  store.dispatch(setResetCompanyService());
  store.dispatch(setResetControlGroup());
  store.dispatch(setResetCustomer());
  store.dispatch(setResetExabeam());
  store.dispatch(setResetGraphApi());
  store.dispatch(setResetJiraTicket());
  store.dispatch(setResetManagedBackup());
  store.dispatch(setResetMbDashboard());
  store.dispatch(setResetMbUsage());
  store.dispatch(setResetModalToggle());
  store.dispatch(setResetMonitoring());
  store.dispatch(setResetMssReport());
  store.dispatch(setResetNotification());
  store.dispatch(setResetObjectStorage());
  store.dispatch(setResetOneServer());
  store.dispatch(setResetOpenNebula());
  store.dispatch(setResetOrder());
  store.dispatch(setResetPermissions());
  store.dispatch(setResetPowerbi());
  store.dispatch(setResetPriceBook());
  store.dispatch(setResetPrivateNetwork());
  store.dispatch(setResetQuickBooks());
  store.dispatch(setResetRedirect());
  store.dispatch(setResetResourcePermission());
  store.dispatch(setResetResource());
  store.dispatch(setResetResourcesStorage());
  store.dispatch(setResetResourcesUsage());
  store.dispatch(setResetRoleMng());
  store.dispatch(setResetRole());
  store.dispatch(setResetSentinelOne());
  store.dispatch(setResetServices());
  store.dispatch(setResetSharepoint());
  store.dispatch(setResetSites());
  store.dispatch(setResetStd());
  store.dispatch(setResetUser());
  store.dispatch(setResetVirtualMachine());
  store.dispatch(setResetVmTemplate());
  store.dispatch(setResetVulnerability());
  store.dispatch(setResetMsSentinel());
  store.dispatch(setResetVirtualRouter());
};
